import React from 'react';
import { H2, F } from 'components/Ui';
import { titleCase } from 'utils/string';
import { formatCurrency } from 'utils/common';
import styles from './styles.scss';

const OrderItem = ({ itemDesc, itemQty, itemPrice }) => (
  <div className={styles.orderItem}>
    {/* <div className={styles.image}>
      {image && <img src={`${image}?fm=webp`} alt="" />}
    </div> */}
    <div className={styles.line}>
      <H2 defaultText={'C60'}>{titleCase(itemDesc)}</H2>
      <p className={styles.qty}>
        <F>QTY</F> {itemQty}
      </p>
    </div>
    <div className={styles.price}>
      <p>{formatCurrency(itemPrice)}</p>
    </div>
  </div>
);

export default OrderItem;
